import React, { createContext, use, useState, useCallback, useMemo, ReactNode } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export class SessionExpiredError extends Error {
  name = 'SessionExpiredError';

  constructor() {
    super('Session has expired');
  }
}

interface SessionExpiryContextValue {
  isExpired: boolean;
  triggerExpiry: () => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const SessionExpiryContext = createContext<SessionExpiryContextValue | null>(null);

export const SessionExpiryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isExpired, setIsExpired] = useState(false);
  const triggerExpiry = useCallback(() => setIsExpired(true), []);
  const value = useMemo(() => ({ isExpired, triggerExpiry }), [isExpired, triggerExpiry]);

  return (
    <SessionExpiryContext value={value}>
      {children}
    </SessionExpiryContext>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSessionExpiry = (): SessionExpiryContextValue => {
  const ctx = use(SessionExpiryContext);
  if (!ctx) {
    throw new Error('useSessionExpiry must be used within a SessionExpiryProvider');
  }
  return ctx;
};
